// extracted by mini-css-extract-plugin
export default {"MonitorPortfolio":"MonitorPortfolio_MonitorPortfolio__-u-yn","labelContainer":"MonitorPortfolio_labelContainer__MOb+r"};